import Dialog from './Dialog';
import React from 'react';

// UK crisis signposting. TapTap is a wellness aid, not a clinical service, so we
// make it easy to reach real help and are explicit about our limits.
const RESOURCES = [
  { name: 'Emergency services', detail: 'Immediate danger to life', action: 'Call 999', href: 'tel:999' },
  { name: 'Samaritans', detail: 'Free, 24/7, any kind of distress', action: 'Call 116 123', href: 'tel:116123' },
  { name: 'NHS 111', detail: 'Urgent but non-emergency help (option 2 for mental health)', action: 'Call 111', href: 'tel:111' },
  { name: 'Shout', detail: 'Free 24/7 crisis text support', action: 'Text SHOUT to 85258', href: 'sms:85258&body=SHOUT' },
];

const CrisisResources = ({ onClose }) => (
  <Dialog onClose={onClose} label="Need to talk to someone?" className="fixed inset-0 z-modal bg-black/80 backdrop-blur-md flex items-center justify-center p-4 pointer-events-auto">
    <div
      className="max-w-md w-full bg-slate-900 border border-white/10 rounded-3xl p-6 shadow-2xl max-h-[85vh] overflow-y-auto overscroll-contain"
      style={{ WebkitOverflowScrolling: 'touch', touchAction: 'pan-y' }}
    >
      <h2 className="text-2xl font-bold text-white mb-2">Need to talk to someone?</h2>
      <p className="text-gray-400 text-sm mb-5">
        TapTap supports relaxation and focus — it is not a substitute for professional care.
        If you are struggling, please reach out.
      </p>

      <div className="space-y-3">
        {RESOURCES.map((r) => (
          <a
            key={r.name}
            href={r.href}
            className="block bg-white/5 hover:bg-white/10 border border-white/10 rounded-2xl p-4 transition-colors"
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-white font-semibold">{r.name}</p>
                <p className="text-gray-400 text-xs">{r.detail}</p>
              </div>
              <span className="text-indigo-300 font-bold text-sm whitespace-nowrap ml-3">{r.action}</span>
            </div>
          </a>
        ))}
      </div>

      <button
        onClick={onClose}
        className="w-full mt-6 py-3 text-white font-bold rounded-2xl bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-500 hover:to-purple-500 transition-all transform active:scale-95 shadow-lg shadow-purple-500/25"
      >
        Close
      </button>
    </div>
  </Dialog>
);

export default CrisisResources;
